import React, { Dispatch, SetStateAction, useCallback } from "react";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { ChevronRightIcon } from "@chakra-ui/icons";
import useTranslation from "next-translate/useTranslation";
import { SmileSignUpSteps } from "../..";
import { useAuthState } from "src/shared/contexts/AuthContext";

const SmileSignupBreadcrumbs = ({
  step,
  setStep,
}: {
  step: SmileSignUpSteps;
  setStep: Dispatch<SetStateAction<SmileSignUpSteps>>;
}) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuthState();

  const LINKS = [
    {
      text: "stepOne",
      step: SmileSignUpSteps.CREATE_STEP,
    },
    {
      text: "stepTwo",
      step: SmileSignUpSteps.INFOS_STEP,
    },
    {
      text: "stepThree",
      step: SmileSignUpSteps.PLANS_STEP,
    },
  ];

  const isCurrentOrPreviousStep = useCallback(
    (targetStep: SmileSignUpSteps) => {
      return targetStep <= step;
    },
    [step]
  );

  const onGoToTargetStep = useCallback(
    (targetStep: SmileSignUpSteps) => {
      if (step === SmileSignUpSteps.CREATE_STEP) {
        return;
      } else if (targetStep !== SmileSignUpSteps.CREATE_STEP) {
        setStep(targetStep);
      }
    },
    [step, isAuthenticated]
  );

  return (
    <Breadcrumb
      marginLeft="auto"
      marginRight="auto"
      marginBottom="40px"
      separator={<ChevronRightIcon color="gray.500" />}
    >
      {LINKS.map((link) => (
        <BreadcrumbItem key={link.text} isCurrentPage={isCurrentOrPreviousStep(link.step)}>
          <BreadcrumbLink
            cursor={link.step !== SmileSignUpSteps.CREATE_STEP ? "pointer" : "default"}
            fontSize={{ base: "11px", sm: "16px" }}
            lineHeight="20px"
            fontWeight={isCurrentOrPreviousStep(link.step) ? "bold" : "normal"}
            color={step === link.step ? "#FF2D55" : "#AEAEB2"}
            onClick={() => onGoToTargetStep(link.step)}
          >
            {t(`smile:pixSignup_${link.text}`)}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};

export default SmileSignupBreadcrumbs;
